import { useMutation, useQueryClient } from '@tanstack/react-query'
import { notificationApi } from '@/services/notifications/notifications'
import { toast } from 'react-toastify'
import { MarkAsReadPayload, SendInvitationPayload } from '@/interfaces/notification'
import { handleError } from '@/utils/helpers'

// Mark specific notifications as read
export const useMarkAsRead = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (payload: MarkAsReadPayload) => notificationApi.markAsRead(payload),
    onSuccess: () => {
      // Invalidate queries to refresh the data
      queryClient.invalidateQueries({ queryKey: ['notifications'] })
    },
    onError: (error: Error) => {
      handleError(error, { fallbackMessage: 'Lỗi khi đánh dấu đã đọc' })
    },
  })
}

// Mark all notifications as read
export const useMarkAllAsRead = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: () => notificationApi.markAllAsRead(),
    onSuccess: () => {
      toast.success('Đã đánh dấu tất cả thông báo là đã đọc')
      queryClient.invalidateQueries({ queryKey: ['notifications'] })
    },
    onError: (error: Error) => {
      handleError(error, { fallbackMessage: 'Lỗi khi đánh dấu tất cả đã đọc' })
    },
  })
}

// Delete a notification
export const useDeleteNotification = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (notificationId: string) => notificationApi.deleteNotification(notificationId),
    onSuccess: () => {
      toast.success('Đã xóa thông báo')
      queryClient.invalidateQueries({ queryKey: ['notifications'] })
    },
    onError: (error: Error) => {
      handleError(error, { fallbackMessage: 'Lỗi khi xóa thông báo' })
    },
  })
}

// Send JD invitation
export const useSendInvitation = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (payload: SendInvitationPayload) => notificationApi.sendInvitation(payload),
    onSuccess: (data) => {
      toast.success(`Đã gửi lời mời tới ${data.invitationsSent} người`)
      queryClient.invalidateQueries({ queryKey: ['notifications'] })
    },
    onError: (error: Error) => {
      handleError(error, { fallbackMessage: 'Lỗi khi gửi lời mời' })
    },
  })
}
